import { render, staticRenderFns } from "./EllipsisTwoLineTooltip.vue?vue&type=template&id=64e6a5e5&scoped=true"
import script from "./EllipsisTwoLineTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./EllipsisTwoLineTooltip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EllipsisTwoLineTooltip.vue?vue&type=style&index=0&id=64e6a5e5&prod&lang=less"
import style1 from "./EllipsisTwoLineTooltip.vue?vue&type=style&index=1&id=64e6a5e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6a5e5",
  null
  
)

export default component.exports